// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2407":"09104f104b66627b","4522":"efe296f01c250ab8","4749":"17d2ede36b187547","7471":"930982dbdd4e04e8","9246":"fde45b7613fcfbbc"}[chunkId] + ".css";
};